import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    ValidationMessage,
    ValidationMessageType,
    SettingState,
    TibboDataType,
    SettingOption,
    Define,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import * as micropython from './micropython';
import * as tios from './tios';
import * as zephyr from './zephyr';
import * as simulator from './simulator';


export default class MQTTLib extends BaseFeature {
    constructor() {
        super();
        this.name = 'MQTT Library';
        this.id = 'mqtt_lib';
        this.icon = 'AiOutlineCloudUpload';
        this.fileLinks = [
            // 'mqtt\\mqtt.tbs',
            // 'mqtt\\mqtt.tbh',
        ];
    }

    getFiles(): string[] {
        if (this.project.runtime === 'tios') {
            return [
                'libraries/mqtt/mqtt.tbh',
                'libraries/mqtt/mqtt.tbs',
            ];
        }
        if (this.project.runtime === 'micropython') {
            return [
                'umqtt/simple.py',
                'async_mqtt.py',
            ];
        }
        return [];
    }

    getDefines(): Array<Define> {
        const defines: Array<Define> = [];
        const capabilities = PlatformUtils.getCapabilities(this.project);
        defines.push({
            name: 'MQTT_LARGE_PACKETS',
            value: '1',
        });

        if (capabilities.includes('tios_g1')) {
            defines.push({
                name: 'MQTT_RX_BUFF',
                value: '1',
            });
            defines.push({
                name: 'MQTT_TX_BUFF',
                value: '1',
            });
        }
        return defines;
    }

    getDependencies() {
        const dependencies = [
            'sock',
            'dns',
        ];
        return dependencies;
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }

    getDetails(): string {
        return `
## MQTT Client library
The device can connect to an MQTT broker to subscribe and poublish to topics.

The device supports both unencrypted and TLS encrypted connections.

The **MQTT Publish** and **On MQTT Notification** blocks can be used with MQTT.

![MQTT blocks](/static/img/blocks_mqtt.png)
        `;
    }
}
